import React from "react"
import styled from "styled-components"
import { IconBreadcrumbsArrow } from "styleguide/icons"
import { uiColorToBaseColor } from "styleguide/styles/colors"

interface Item {
  title: string
  link: string
}

interface Props {
  items: Item[]
  currentItem: string
  className?: string
}

const Wrapper = styled.div`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;

  svg {
    width: 4px;
    height: 6px;
    margin: 0 7px;
  }

  a,
  span {
    color: ${uiColorToBaseColor("gray")};
    font-weight: 500;
  }
`

const Breadcrumbs = ({ items, currentItem, className }: Props) => (
  <Wrapper className={className}>
    {items.map((item, index) => (
      <React.Fragment key={index}>
        <a href={item.link}>{item.title}</a>
        <IconBreadcrumbsArrow />
      </React.Fragment>
    ))}
    <span>{currentItem}</span>
  </Wrapper>
)

export default Breadcrumbs
